/* global axios */
import ApiClient from './ApiClient';

// Contratos do negócio (aba Contrato). Nascem de uma proposta da conversa; o
// texto sai congelado do backend e o cliente assina no link público /ct/:token.
class ContractsAPI extends ApiClient {
  constructor() {
    super('contracts', { accountScoped: true });
  }

  availability() {
    return axios.get(`${this.url}/availability`);
  }

  issuer() {
    return axios.get(`${this.url}/issuer`);
  }

  updateIssuer(issuer) {
    return axios.put(`${this.url}/issuer`, { issuer });
  }

  list(conversationId) {
    return axios.get(this.url, { params: { conversation_id: conversationId } });
  }

  createContract(payload) {
    return axios.post(this.url, payload);
  }

  markSent(id) {
    return axios.patch(`${this.url}/${id}`, { status: 'sent' });
  }

  cancelContract(id) {
    return axios.patch(`${this.url}/${id}`, { status: 'canceled' });
  }

  deleteContract(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default new ContractsAPI();
